import React from 'react';
import PropTypes from 'prop-types';

import {dispatch, connect} from 'utils/state_manager';

import {Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography} from 'views/components';
import {Translate} from 'views/module';

import AddWidgetAccordion from './utils/AddWidgetAccordion';
import {WIDGET_MAPPER} from './index';
import _ from 'lodash';

const AddWidgetModal = (props) => {
  const [selectedWidgetType, setSelectedWidgetType] = React.useState(null);
  const [expandedAccordion, setExpandedAccordion] = React.useState(null);

  const {
    saveModal,
    closeModal,
  } = props;

  const isDisabled = () => {
    return selectedWidgetType ? false : true;
  };

  const ACCORDION_MAPPER_DATA = {
    'TEASER': [],
    'PAYMENT': [],
  };

  const prepareMapper = () => {
    Object.entries(WIDGET_MAPPER).map(([widgetType, widgetData]) => {
      ACCORDION_MAPPER_DATA[widgetData.type].push({
        widgetType: widgetType,
        widgetData: widgetData,
      });
    });
  };

  prepareMapper();

  return (
    <Dialog onClose={closeModal}>
      <DialogTitle onClose={closeModal} >
        <Translate expression='dashboard.Customization.AddWidget'/>
      </DialogTitle>
      <DialogContent sx={{overflowY: 'auto', maxHeight: {md: '65vh', xs: '85vh'}}}>
        <Typography>
          <Translate expression='dashboard.Customization.SelectWidget'/>
        </Typography>
        {
          Object.entries(ACCORDION_MAPPER_DATA).map(([type, widgetList]) => {
            if (_.isEmpty(widgetList)) return null;

            return (
              <AddWidgetAccordion
                key={type}
                accordionTitle={type}
                widgetList={widgetList}
                expandedAccordion={expandedAccordion}
                setExpandedAccordion={setExpandedAccordion}
                selectedWidgetType={selectedWidgetType}
                setSelectedWidgetType={setSelectedWidgetType}
              />
            );
          })
        }
      </DialogContent>
      <DialogActions sx={{minHeight: '20px'}}>
        <Button onClick={closeModal} variant='outlined'>
          <Translate expression='generic.Close'/>
        </Button>
        <Button
          onClick={() => saveModal(selectedWidgetType)}
          disabled={isDisabled()}
          color="primary"
        >
          <Translate expression='generic.Add'/>
        </Button>
      </DialogActions>
    </Dialog >
  );
};

AddWidgetModal.propTypes = {
  saveModal: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
});

export default connect(mapStateToProps, dispatch)(React.memo(AddWidgetModal));
